module.exports = __webpack_public_path__ + "static/media/photo215.7ec89b4b.jpg";